export function fancyDate(value, format = 'long') {
    if (!value) return "";

    const raw = String(value).replace(" ", "T");
    const date = new Date(raw);
    if (isNaN(date.getTime())) return "";

    const day = date.getDate();
    const monthIdx = date.getMonth();
    const year = date.getFullYear();

    if (format === 'short') {
        // 09.09.2009 (с ведущими нулями)
        const dd = String(day).padStart(2, '0');
        const mm = String(monthIdx + 1).padStart(2, '0');
        return `${dd}.${mm}.${year}`;
    }

    // long (по умолчанию): "1 октября 2025 года"
    const months = [
        "января", "февраля", "марта", "апреля", "мая", "июня",
        "июля", "августа", "сентября", "октября", "ноября", "декабря"
    ];
    const month = months[monthIdx];
    return `${day} ${month} ${year} года`;
}

export function fancyDateShort(value) {
    return fancyDate(value, 'short');
}
